import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var UpdatedByLogService = /** @class */ (function () {
    function UpdatedByLogService(translateService) {
        this.translateService = translateService;
        this.customAuthorDeviceMapper = Object.freeze({
            mountdoom: 'laptop',
            lorgan: 'upload',
            gorgoroth: 'smartphone',
            system: 'settings',
        });
    }
    UpdatedByLogService.prototype.customUpdatedByInLogs = function (logs) {
        var e_1, _a;
        try {
            for (var logs_1 = tslib_1.__values(logs), logs_1_1 = logs_1.next(); !logs_1_1.done; logs_1_1 = logs_1.next()) {
                var log = logs_1_1.value;
                log = this.generateUpdateByLog(log);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (logs_1_1 && !logs_1_1.done && (_a = logs_1.return)) _a.call(logs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return logs;
    };
    UpdatedByLogService.prototype.generateUpdateByLog = function (log) {
        var logCustomAuthor = {
            type: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.UPDATED'),
            updatedByName: null,
            clientApplicationName: null,
        };
        if (log.isEquipmentCreatedLog) {
            logCustomAuthor.type = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.CREATED');
        }
        if (log.updatedBy && log.updatedBy.name) {
            logCustomAuthor.updatedByName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.BY_AUTHOR', {
                authorName: log.updatedBy.name
            });
        }
        if (!log.clientApplicationName) {
            log.clientApplicationName = 'mountdoom';
        }
        logCustomAuthor.clientApplicationName = this.translateService.instant("EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.DEVICES." + log.clientApplicationName.toUpperCase());
        if (Object.values(logCustomAuthor).filter(Boolean).length >= 2) {
            log.customAuthorDevice = this.customAuthorDeviceMapper[log.clientApplicationName.toLowerCase()];
            log.customAuthor = Object.values(logCustomAuthor).filter(Boolean).join(' ');
        }
        if (log.approval && log.approvedStatus === 'pending') {
            log.customAuthor = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.AUTHOR_CREATED', {
                company: log.approval.company.name
            });
            log.customAuthorDevice = 'settings';
        }
        return log;
    };
    UpdatedByLogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UpdatedByLogService_Factory() { return new UpdatedByLogService(i0.ɵɵinject(i1.TranslateService)); }, token: UpdatedByLogService, providedIn: "root" });
    return UpdatedByLogService;
}());
export { UpdatedByLogService };
